import { MenuItem } from 'src/utils/shared-types'

export const tenants: MenuItem[] = [
  { id: 'AHS', value: 'AHS', label: 'AHS' },
  { id: 'HSA', value: 'HSA', label: 'HSA' },
  { id: 'PC', value: 'ProConnect', label: 'ProConnect' },
]
